/**
 * B_Canvas.js
 *
 * @목적 :
 * @설명 :
 * @진행 :
 * @주의 :
 * @이슈 :
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import B_Define from 'canvas/base/dev/util/B_Define';
import B_Util from 'canvas/base/dev/util/B_Util';
import B_Tool from 'canvas/base/dev/frame/B_Tool';
import B_Resource from 'canvas/base/dev/model/B_Resource';
import B_Preload from 'canvas/base/dev/util/B_Preload';
import {isDist} from 'canvas/base/dev/util/B_Config';

const B_Canvas = (function () {

	/**
	 * [B_Canvas - 기능명세]
	 *
	 * - 캔버스 (createjs)
	 * - 프리로드
	 * - 월드
	 * - 툴스
	 * */

	const $ = {
		_wrapper: null, // {obj}
		_canvas: null, // {obj}
		_sound: null, // {obj}
		_speed: null, // {obj}
		_res: null, // {json}
		_resTool: null, // {json}
		_resWorld: null, // {json}
		_active: null, // {bool}
		_preload: null, // {obj}
		_tool: null, // {obj}
		_world: null, // {obj}
		_env: null, // {obj}
		_animate: null, // {obj}
		_gameType: null, // {str} 게임 타입
		boolEnd : null, // {bool} 논리 종료 - 캔버스가 종료 상태인지
		boolStop : null, // {bool} 논리 중지 - 캔버스가 중지 상태인지
		boolStopWatchers : null, // {arr} 중지 와쳐 - 캔버스가 중지되면 처리되는 함수 배열
		onCanvasWorldInit: null, // {func}
		onCanvasToolInit: null, // {func}
		onCanvasEvent: null // {func}
	};

	class B_Canvas {

		constructor(wrapper, id, queue, userCB) {

			// [T] global test object
			if (!isDist()) window.CM = this;

			// [E] id exception
			if (typeof id == 'undefined') { B_Util.print(B_Define.MESSAGE['NO_CANVAS_ID']); return; }

			// [S] init
			this.WRAPPER = wrapper; // [#] Wrapper
			this.propertyInit(); // [#] property init
			this.STAGE = this.canvasInit(id); // [#] canvas init & set stage

			// [S] preload - tool
			this._res = {};
			this.preloadTool();

			// [S] preload - world
			// this._preload = this._getPreload(); // # Preload
			if (typeof userCB != 'undefined') this.onCanvasWorldInit = userCB; // # 생성자 Callback
			if (typeof queue != 'undefined') this.preloadWorld(queue); // # Preload 실행

			// [#] onCanvasInit (prototype)
			if (typeof this.onCanvasInit != 'undefined') this.onCanvasInit();
		}

		// [V] public 변수 ( => 이곳에 처리된 변수 이외에는 모두 '_' 처리)

		// @DES(public) :: time {num} - 기본시간 (외부접근금지)
		get time() { return parseInt( B_Define.INTERVAL / this.speed ); }
		set time(t) { /*...*/ }

		// @DES(public) :: timer {num} - watcher 설정
		get timer() { return $._timer; }
		set timer(t) {
			this.timerWatchers.forEach((v) => { v('timer', this._timer, t); });
			$._timer = t;
		}

		// @DES(public) :: gameType {str} - 게임 타입
		get gameType() { return $._gameType; }
		set gameType(gy) { /*...*/ }

		// @DES(public) :: onCanvasEvent {func} - Count 자동 적용
		get onCanvasEvent() { return $.onCanvasEvent; };
		set onCanvasEvent(ce) { $.onCanvasEvent = ce; };

		// @DES(public) :: boolStop {bool} - 'boolStopWatcher'를 가지고 있습니다.
 		get boolStop() { return $._boolStop; }
		set boolStop(t) {
			$._boolStop = t;

			// [#] boolStop watcher 실행부분
			if(typeof this.boolStopWatcher != 'undefined') {
				this.boolStopWatcher.forEach((v) => { v('boolStop', $._boolStop, t); });
			}
		}

		// @DES(public) :: patioWidth & patioHeight
		get patioWidth() { return this.CANVAS.scrollWidth / this.CANVAS.width; };
		get patioHeight() { return this.CANVAS.scrollHeight / this.CANVAS.height; };

		// @DES(public) :: canvasMouseX & canvasMouseY
		get canvasMouseX() { return this.STAGE.mouseX; };
		get canvasMouseY() { return this.STAGE.mouseY; };

		// // @DES(public) :: speed {num} - 스피드 객체 (Ticker 동시 업데이트)
		// get speed() { return $._speed; }
		// set speed(s) {
		// 	if(!B_Util.checkSpeed(s)) { B_Util.print('[코드모스] => 스피드가 올바르지 않습니다.'); return; }
		// 	else {
		// 		$._speed = s;
		// 		createjs.Ticker.setFPS(30 * s);
		// 	}
		// }

		// [F] public

		/**
		 * [Function :: propertyInit]
		 *
		 * @DES :: canvas 속성관련 초기화
		 * @IP1 :: null
		 * @O.P :: null
		 * @S.E ::
		 */
		propertyInit() {
			// [#] boolEnd
			this.boolEnd = false;

			// [#] boolStop & boolStopWatcher
			this.boolStop = false;
			this.boolStopWatcher = [
				(name, oldOne, newOne) => {
					// [#] 타이머가 있다면
					if(this.timer) { if(newOne === false /*stop === false*/) this.loopTimer();}
				}
			];

			// [#] speed
			// if(!B_Util.checkSpeed(this.spd)) this.spd = B_Define.SPEED;
			// this.speed = this.spd;

			// [#] timer & timerWatchers
			this.timerWatchers = [];
		}

		/**
		 * [Function :: canvasInit]
		 *
		 * @DES :: createjs 관련 캔버스 초기화
		 * @IP1 :: canvasID {str}
		 * @O.P :: STAGE {obj}
		 * @S.E ::
		 */
		canvasInit(canvasId) {
			try {
				this.CANVAS = document.getElementById(canvasId); // # Canvas

				// Canvas Wrapper 처리
				// /*[T]*/console.log(B_Define.DOM_CANVAS_WRAPPER_ID);
				// /*[T]*/console.log(document.getElementById(B_Define.DOM_CANVAS_WRAPPER_ID));
				if (
					typeof document.getElementById(B_Define.DOM_CANVAS_WRAPPER_ID) == 'undefined'
					||
					document.getElementById(B_Define.DOM_CANVAS_WRAPPER_ID) == null
				) {
					this.CANVAS_WRAPPER = document.createElement('div');
					this.CANVAS_WRAPPER.setAttribute("id", B_Define.DOM_CANVAS_WRAPPER_ID);
					this.CANVAS_WRAPPER.style.display = "inline-block";
					this.CANVAS.parentNode.appendChild(this.CANVAS_WRAPPER);
					this.CANVAS_WRAPPER.appendChild(this.CANVAS);
				} else {
					this.CANVAS_WRAPPER = document.getElementById(B_Define.DOM_CANVAS_WRAPPER_ID);
				}

				// Canvas 처리
				const STAGE = new createjs.Stage(this.CANVAS); // # Stage
				createjs.Ticker.addEventListener("tick", STAGE); // # Tick
				createjs.Ticker.setFPS(B_Define.FPS); // # FPS
				STAGE.enableMouseOver(10); // # Mouse Hover
				STAGE.enableDOMEvents(true); // # Dom
				STAGE.mouseMoveOutside = true; // Mouse

				// [T] 좌표 확인 리스너 (지우지마세여...)
				STAGE.on('click', (e) => {
					// B_Util.print(e);
					B_Util.print('position :: ' + e.stageX + ', ' +  e.stageY);
				});

				return STAGE;
			} catch (e) {
				B_Util.print(B_Define.MESSAGE["ERROR"] + e);
			}
		}

		/**
		 * [Function :: start]
		 *
		 * @DES :: 캔버스 활성화
		 * @S.E ::
		 */
		start() {
			this.boolStop = false;
			if(this.TOOL) { this.TOOL[B_Define.DISABLED_ID].toggle(false); }
		}

		/**
		 * [Function :: stop]
		 *
		 * @DES :: 캔버스 비활성화
		 * @IP1 :: numAlpha {num}
		 * @O.P :: null
		 * @S.E ::
		 */
		stop(numAlpha) {
			this.boolStop = true;
			if(this.TOOL) {
				this.TOOL[B_Define.DISABLED_ID].setAlpha(numAlpha ? numAlpha : B_Define.DISABLED_ALPHA);
				this.TOOL[B_Define.DISABLED_ID].toggle(true);
			}
		}

		/**
		 * [ Function :: loopTimer ]
		 *
		 * @DES :: 타이머 진행함수
		 * @S.E ::
		 */
		loopTimer() {
			setTimeout(() => {
				// [*] 캔버스 종료면 타이머 진행되지 않습니다.
				if(!this.boolEnd && !this.boolStop) {
					this.timer -= 1;
					/*진행*/
					if(this.timer > 0) this.loopTimer();
					/*종료*/
					else {
						if(this.onCanvasEvent) {

							// [S] state 처리
							const STATE = this.WORLD.STATE;
							STATE.stop(B_Define.CLEAR_STATUS['GOING'], B_Define.REASON['TIMEOVER']);

							// [S] disabled 처리 => 상위사용자가 처리하도록함
							// this.TOOL.disabled.toggle();

							// [S] boolEnd 처리
							this.boolEnd = true;

							this.onCanvasEvent(STATE.renew());
						}
					}
				}
			}, 1000);
		}

		/**
		 * [Function :: removeWorldChild]
		 *
		 * @DES :: 월드 객체 모두 삭제
		 * @IP1 ::
		 * @O.P ::
		 * @S.E ::
		 */
		removeWorldChild(){
			try {
				// [#] Proton 관련
				// [#] how to use garbage collection ?
				this.ANIMATE._proton.getArrProton().forEach((p) => {
					p.active = false;
					for (let key in p) delete p[key];
				});
				this.ANIMATE._proton.getArrEmitter().forEach((e) => {
					for (let key in e) delete e[key];
				});
				this.ANIMATE._proton.getArrRenderer().forEach((r) => {
					for (let key in r) delete r[key];
				});
				this.ANIMATE._proton.setArrProton([]);
				this.ANIMATE._proton.setArrEmitter([]);
				this.ANIMATE._proton.setArrRenderer([]);

				// [#] Canvas 관련 => World 제거
				this.STAGE.children.forEach((v, i) => {
					if (v.identification !== B_Define.TOOL_TYPE) {
						delete this.STAGE.children.splice(i, 1);
					}
				});

				// [#] Dom 관련
				if (
					typeof this.CANVAS_WRAPPER !== 'undefined'
					&&
					typeof this.CANVAS_WRAPPER.childNodes !== 'undefined'
				) {
					this.CANVAS_WRAPPER.childNodes.forEach((v) => {
						if (
							v.tagName.toLowerCase() != "canvas"
							&&
							(
								typeof v.getAttribute("type") == "string"
								&&
								v.getAttribute("type").toLowerCase() != B_Define.TOOL_TYPE
							)
						) {
							this.CANVAS_WRAPPER.removeChild(v);
						}
					});
				}
			} catch (e) {
				B_Util.print(B_Define.MESSAGE["ERROR"] + e);
			}
		}

		/**
		 * [Function :: removeEntryChild]
		 *
		 * @DES :: 모든 객체 삭제
		 * @O.P ::
		 * @S.E ::
		 */
		removeEntryChild() { /*...*/ }

		/**
		 * [Function :: preloadTool]
		 *
		 * @DES :: tool preload
		 * @I.P :: null
		 * @O.P :: null
		 * @S.E :: onCanvasToolInit 내부에 존재
		 */
		preloadTool() {
			(new B_Preload(B_Define.TOOL_IMAGE_FOLDER, B_Resource)).handleQueue(B_Define.TOOL_QUEUE, (rtn) => {
				this._resTool = rtn;
				Object.assign(this._res, this._resTool);

				// [S] init tool
				this.TOOL = new B_Tool(this);
				this.STAGE.addChild(this.TOOL);

				// [#] onCanvasToolInit
				if (this.onCanvasToolInit) this.onCanvasToolInit(this.WRAPPER.tool);
			});
		}

		/**
		 * [Function :: preloadWorld]
		 *
		 * @DES :: 캔버스 요소를 재설정해서 다른 설정값의 캔버스를 불러옵니다. (reload)
		 * @IP1 :: queue {json}
		 * @IP2 :: cb {func}
		 * @O.P ::
		 * @S.E ::
		 */
		preloadWorld(queue, cb) {
			(new B_Preload(this.src, B_Resource)).handleQueue(queue, (res) => {
				// /*[T]*/ console.log('preload end');
				this._resWorld = res;
				Object.assign(this._res, this._resWorld);

				if (cb) cb();    // <- Preload Callback
				this.postload(); // <- 생성자 Callback
			});
		}

		/**
		 * [ Function :: postload ]
		 *
		 * @DES :: 설정된 요소를 다시 가동해서 캔버스를 재시작합니다. (replay)
		 * @IP1 :: middleware {func}
		 * @O.P :: null
		 * @S.E :: 함수 진행 중간에 넣고 싶은 로직이 있다면 'middleware'를 통해 처리 할 수 있습니다.
		 */
		postload(middleware) {
			// /*[T]*/console.log('postload start');

			// [S] game count
			if(typeof this.gameCount !== 'undefined') this.gameCount = this.gameCount + 1;
			else this.gameCount = 1;

			// [S] stage remove
			this.removeWorldChild();

			// [I] init world
			this.WORLD = this._getWorld(); // [#] 새로운 월드 생성
			this.STAGE.addChild(this.WORLD); // [#] 새로운 월드 적용
			this.STAGE.swapChildren(this.WORLD, this.TOOL); // [#] 위치 변경 (with Tool)

			// [I] init wrapper world
			this.WRAPPER.world = {};

			// [#] 게임 타입별 추가 로직 적용 (G, S, C...)
			if(typeof middleware !== 'undefined') middleware();

			// [#] callback -> 사용자가 호출한 Callback Function
			if(this.onCanvasWorldInit) this.onCanvasWorldInit(this.WRAPPER, this._resWorld);
		}

	}
	B_Util.manageGetAndSet(B_Canvas, $);
	return B_Canvas;
}());

export default B_Canvas;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/frame/B_Canvas.js